import { Injectable } from '@angular/core';
import { MarketId, BoardId } from '../model/common';

@Injectable({
  providedIn: 'root'
})
export class MarketHelper {

  resolveFullName(market: MarketId): {name: string}
  resolveFullName(market: MarketId, board: BoardId): {name: string; board: string; boardShort: string}
  resolveFullName(market: MarketId, board?: BoardId): {name: string, board?: string, boardShort?: string}
  resolveFullName(market: MarketId, board?: BoardId): {name: string, board?: string, boardShort?: string} {
    const name = this.resolveMarketName(market)

    if (board) {
      switch (market) {
        case 'binance':
          switch (board) {
            case 'usdm':
              return {name, board: 'USDⓈ-M Futures', boardShort: 'USDⓈ-M'}
            default: throw new Error(`Unknown ${board}`)
          }

        case 'bybit':
          switch (board) {
            case 'linear':
              return {name, board: 'Perpetual', boardShort: 'Perp'}
            default: throw new Error(`Unknown ${board}`)
          }

        case 'okx':
          switch (board) {
            case 'swap':
              return {name, board: 'Swap', boardShort: 'Swap'}
            default: throw new Error(`Unknown ${board}`)
          }

        default: throw new Error(`Unknown ${market}`)
      }
    }

    return {name}
  }

  resolveMarketName(market: MarketId) {
    switch (market) {
      case 'binance':
        return 'Binance'
      case 'bybit':
        return 'Bybit'
      case 'okx':
        return 'OKX'
      default: throw new Error(`Unknown ${market}`)
    }
  }

  resolveDefaultBoard(market: MarketId): BoardId {
    switch (market) {
      case 'binance': return 'usdm'
      case 'bybit': return 'linear'
      case 'okx': return 'swap'
      default: throw new Error(`Unknown market ${market}`)
    }
  }

  validateMarketBoard(market: string, board: string) {
    switch (market) {
      case 'bybit':
        switch (board) {
          case 'linear': return true
        }
        break
      case 'binance':
        switch (board) {
          case 'usdm': return true
        }
        break
      case 'okx':
        switch (board) {
          case 'swap': return true
        }
        break
    }
    return false
  }

  resolveDefaultSymbol(market: MarketId, board: BoardId): string {
    const id = `${market}:${board}`
    switch (id) {
      case 'binance:usdm': return 'BTCUSDT'
      case 'bybit:linear': return 'BTCUSDT'
      case 'okx:swap': return 'BTC-USDT-SWAP'
      default: throw new Error(`Unknown market ${market} ${board}`)
    }
  }

}
